module.exports = __webpack_public_path__ + "images/marshall9c3c8b6250e3a68eb48ce463ce22b403.png";